import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/completed.png'


const _hoisted_1 = {
  key: 0,
  class: "relative"
}
const _hoisted_2 = {
  key: 0,
  class: "absolute z-10 top-0 right-0"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "pt-1 pr-1 w-8",
  src: _imports_0,
  alt: "済"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.video)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.toArray(_ctx.video.video_watch_completions).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["aspect-w-16 aspect-h-9", [_ctx.rounded ? 'rounded overflow-hidden' : '']])
        }, [
          (_ctx.thumbnailUrl === undefined)
            ? (_openBlock(), _createElementBlock("iframe", {
                key: 0,
                loading: "lazy",
                src: _ctx.video.embed_url,
                frameborder: "0",
                class: "pointer-events-none"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                loading: "lazy",
                src: _ctx.thumbnailUrl,
                alt: "thumbnail"
              }, null, 8, _hoisted_6))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(`text-gray-700 text-sm font-medium truncate mt-1 ${_ctx.titleAlign}`)
        }, _toDisplayString(_ctx.video.title), 3)
      ]))
    : _createCommentVNode("", true)
}